// Money arithmetic in JS accumulates binary floating-point error (300 - 277.2 =
// 22.80000000000001). Round every computed amount to cents before storing it in
// state or rendering it, so the value itself is clean and not just its display.
//
// The shift is done through the decimal exponent instead of `* 100`, because the
// multiplication reintroduces the very error we are removing: 1.005 * 100 is
// 100.49999999999999, so `Math.round(amount * 100) / 100` would yield 1 for a
// value that must round to 1.01. Ties go up (`Math.round` semantics), which for
// negative amounts means toward zero: -1.005 rounds to -1.
export const roundToCents = (amount: number) => Number(`${Math.round(Number(`${amount}e2`))}e-2`);

export const formatToCurrency = (amount: number, maximumFractionDigits = 2) => {
  const options = {
    style: 'currency',
    currency: 'MXN',
    maximumFractionDigits,
  } as const;

  return amount.toLocaleString('es-MX', options);
};
